import React from 'react';
import ListEntry from '../../../shared/ListEntry'
import { personSubTitle } from '../../../../common';
import { getCurrentLanguage } from '../../../../localData';

const ObjectRelPersonsPerson = (props) => {
    const entry = {
        title: props.person.PerNameTxt,
        txt: personSubTitle(props.person),
        linkUrl: `/${getCurrentLanguage()}/person/${ props.person.PerId }`,
        imageUrl: props.person.PerUrl
    };

    return <ListEntry entry={ entry } />
};

export default ObjectRelPersonsPerson;


// WEBPACK FOOTER //
// ./app/components/Object/RelPersons/Person/ObjectRelPersonsPerson.jsx